import axios from 'axios';
import common from '@/config/common';
import authProvider from '@/setup/auth-provider';

const auth = authProvider();
const conversationsUrl = `${common.discoveryEndPoint()}/v2/starfish/conversations`;

async function getAuthHeaders() {
  const token = await auth.bearerToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default {
  async fetchSampleQuestions(siteChatAgentId) {
    const { data } = await axios.get(`${common.discoveryEndPoint()}/v2/ai/agent/sources/${encodeURIComponent(siteChatAgentId)}/sample-questions`, {
      headers: await getAuthHeaders(), timeout: 15000,
    });
    return data;
  },
  async fetchSources() {
    const { data } = await axios.get(`${common.discoveryEndPoint()}/v2/ai/agent/sources`, {
      headers: await getAuthHeaders(),
    });
    return data;
  },
  async cancelRequest(conversationId, requestId) {
    await axios.post(`${common.discoveryEndPoint()}/v2/ai/agent/conversations/${conversationId}/requests/${requestId}/cancel`, {}, {
      headers: await getAuthHeaders(), timeout: 30000,
    });
  },
  async fetchConversations() {
    const { data } = await axios.get(conversationsUrl, {
      headers: await getAuthHeaders(),
    });

    return data;
  },

  async fetchConversation(conversationId) {
    const { data } = await axios.get(`${conversationsUrl}/${conversationId}`, {
      headers: await getAuthHeaders(),
    });

    return data;
  },
};
